import React from "react";
import { connect } from "react-redux";
import { showToast } from "Source/globalFunction";
import { postData } from "Source/globalFunction";
@connect(store => {
    return {
        project: store.project
    }
})

class Invite extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showConfirm: false, loading: false };
    }

    render() {
        const { dispatch, member, project } = this.props;

        const handleInvite = () => {
            this.setState({ showConfirm: true });
        };

        const handleConfirmInvite = () => {
            this.setState({ loading: true });
            const url = `/api/project-members/${member.id}/invite`;
            postData(url, {}, (response) => {
                if (response) {
                    showToast("success", "Member has been successfully invited.");
                    if (typeof this.props.onUpdateMember === 'function') {
                        this.props.onUpdateMember({ ...member, status: "enabled", isInvited: true });
                    }
                } else {
                    showToast("error", "Failed to send invitation");
                }
                dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                this.setState({ showConfirm: false, loading: false });
            });
        };

        const handleCancelConfirm = () => {
            this.setState({ showConfirm: false, loading: false });
        };

        return (
            <React.Fragment>
                {(member.status === "enabled" || member.memberType === "project manager") && <button class="disabled">Invite</button>}
                {member.status === "disabled" && member.memberType !== "project manager" && (
                    <button
                        class={`active ${member.isInvited ? "invited sent" : ""}`}
                        onClick={handleInvite}
                        style={member.isInvited ? { backgroundColor: '#5081FF', color: '#fff' } : {}}
                    >Invite</button>
                )}
                {member.status === "invited" && member.memberType !== "project manager" && (
                    <button
                        class={`active ${member.isInvited ? "invited sent" : ""}`}
                        onClick={handleInvite}
                        style={member.isInvited ? { backgroundColor: '#5081FF', color: '#fff' } : {}}
                    >Re-invite</button>
                )}
                {this.state.showConfirm && (
                    <div className="confirm-modal bg-overlay" id="invite-user" style={{position: 'fixed', top: 0, left: 0, width: '100vw', zIndex: 2000, background: 'rgba(0,0,0,0.3)'}}>
                        <div className="modal-dialog modal-md" role="document" >
                            <div className="modal-content" style={{borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.18)'}}>
                                <div className="modal-header border-none" style={{ paddingBottom: '0px'}}>
                                    <div  style={{alignItems: 'center'}}>
                                        <div className=" col-md-10 col-sm-10">
                                            <p className="text-size18 text-black text-semi-bold mb0" style={{marginBottom: 0, textAlign: 'left', padding: 0}}>You are about to invite this member</p>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2" style={{textAlign: 'right'}}>
                                            <a className="text-right text-black" aria-label="Close" onClick={handleCancelConfirm} style={{cursor: 'pointer'}}>
                                                <i className="material-icons text-black text-size22">close</i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body bt" style={{padding: '10px 28px 10px 28px'}}>
                                    <p className="m0 text-black" style={{margin: 0}}>Inviting this member will grant them access to this account.<br />Please review their accesses on each module. Do you wish to proceed?</p>
                                </div>
                                <div className="modal-footer bt" style={{padding: '0px 10px 0px'}}>
                                    <div  style={{alignItems: 'center'}}>
                                        <div className="col-lg-4 col-md-4 col-sm-4">
                                            <button type="button" className="btn btn-secondary btn-cancel text-black" onClick={handleCancelConfirm} style={{width: '100%', borderRadius: 6, background: '#f5f5f5', color: '#333', border: '1px solid #ccc', paddingLeft: 0}}>No</button>
                                        </div>
                                        <div className="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-save"
                                                onClick={this.state.loading ? undefined : handleConfirmInvite}
                                                style={{ borderRadius: 6, minWidth: 100, background: '#5081FF', color: '#fff', border: 'none', position: 'relative', opacity: this.state.loading ? 0.7 : 1 }}
                                                disabled={this.state.loading}
                                            >
                                                Yes
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default Invite;